export * from './wk-delete-decorators-dialog.component';
